import React from 'react';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CheckIcon from '@mui/icons-material/Check';
import ArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import example_1 from './example_1.png';
import example_2 from './example_2.png';
import example_3 from './example_3.png';

const useStyles = makeStyles((theme) => ({
    bars: {
        position: 'absolute',
        top: '25%',
        left: -50,
        width: '50% !important',
        zIndex: 1,
        transform: 'rotateX(45deg) rotateY(10deg) rotateZ(-35deg)',
    },
    bar: {
        transition: 'transform .2s ease-in-out',
        '&:hover': {
            transform: 'translateX(25px) translateY(-25px) !important',
            transformOrigin: 'center bottom',
        },
    },
    description: {
        position: 'absolute',
        bottom: '20%',
        right: theme.spacing(4),
        width: 'max-content !important',
        maxWidth: '50vw',
    },
    footnote: {
        position: 'absolute',
        left: '50%',
        bottom: 24,
        transform: 'translateX(-50%)',
    },
}));

const Details = () => {
    const classes = useStyles();

    return (
        <>
            <Grid container direction="column" className={classes.bars}>
                <img src={example_1} alt="example 1" className={classes.bar} />
                <img src={example_2} alt="example 2" className={classes.bar} />
                <img src={example_3} alt="example 3" className={classes.bar} />
            </Grid>

            <Grid container alignItems="center" spacing={2} className={classes.description}>
                <Grid item xs={1}><CheckIcon color="secondary" /></Grid>
                <Grid item xs={11}><Typography variant="h4">An illusion of linear typing experience</Typography></Grid>
                <Grid item xs={1}><CheckIcon color="secondary" /></Grid>
                <Grid item xs={11}><Typography variant="h4">Progressive search query construction</Typography></Grid>
                <Grid item xs={1}><CheckIcon color="secondary" /></Grid>
                <Grid item xs={11}><Typography variant="h4">Intuitive user interactions</Typography></Grid>
                <Grid item xs={1}><CheckIcon color="secondary" /></Grid>
                <Grid item xs={11}><Typography variant="h4">Flat learning curve</Typography></Grid>
                <Grid item xs={1}><CheckIcon color="secondary" /></Grid>
                <Grid item xs={11}><Typography variant="h4">No human errors</Typography></Grid>
                <Grid item xs={1}><CheckIcon color="secondary" /></Grid>
                <Grid item xs={11}><Typography variant="h4">Many more ...</Typography></Grid>
            </Grid>

            <Typography variant="botton" align="center" className={classes.footnote}>
                scroll down to see the live demo in the next page
                <br /><br />
                <ArrowDownIcon />
            </Typography>
        </>
    );
};

export default Details;
